import Link from 'components/link/Link';

import { IStickyMenuOnTabsItem } from 'source/NFR.types';

const StickyMenuOnTabsItem: React.FC<IStickyMenuOnTabsItem> = ({ link }) => {
  return (
    <li className="sticky-menu-on-tabs-item">
      <Link {...link} theme="actionLink" />
    </li>
  );
};

StickyMenuOnTabsItem.displayName = 'StickyMenuOnTabsItem';

export default StickyMenuOnTabsItem;
